import { IonAlert, IonButton, IonCol, IonGrid, IonIcon, IonInput, IonItem, IonList, IonRow } from '@ionic/react';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getConfig } from '../../appConfig';
import Basket from '../../lib/basket';
import api from '../../lib/api';
import { withTranslation } from '../../lib/translate';
import { deepCopy, forwardTo, getGiftCardNumber, getPointsValuePercentage, isDefined, isEmptyObject, isWebConfig, makeKey, openExternalLink, weekdays } from '../../lib/utils';
import { getIkentooMenusForLocation, removeVoucher, setCommonProp, setModal } from '../../store/actions';
import { NormalText, SmallText, Spacer, StrongText, Subtitle, Title } from '../common';
import { closeOutline, trashBinOutline } from 'ionicons/icons';
import Incrementer from '../incrementer';
import Modal from '../modal';
import './index.css';
import moment from 'moment';
import { GET_TAX } from '../../store/constants';
import CheckoutAllergens from '../checkoutAllergens';
import Slider, { Slide } from '../slider';
import ModalItem from '../modalItem';

class OrderContent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			serviceChargeModalOpen: false,
			showCharge: false,
			serviceChargeAmount: null,
			serviceChargeBoxModalOpen: false,
			removeItem: {},
			showRemoveItemAlert: false,
			removeItemAlertFunction: () => null,
			removeServiceChargeModal: false,
			selectedUpsellItem: null,
			rawUpsellData: [],
			upsellData: [],
		};
	}

	filterUpsellData = (rawUpsellData) => {
		if (Basket.has_multi_basket) {
			return rawUpsellData.map((restaurantData) => {
				const basketRestaurant = Basket.multi_basket_items.find(
					(r) => r.restaurant?.business_location_id === restaurantData.restaurant
				);
				const basketSkus = new Set((basketRestaurant?.items || []).map((i) => i.item.sku));
				return { ...restaurantData, items: restaurantData.items.filter((item) => !basketSkus.has(item.sku)) };
			});
		}
		const basketSkus = new Set(Basket.items.map((i) => i.item.sku));
		return rawUpsellData.flat().filter((item) => !basketSkus.has(item.sku));
	};

	fetchUpsellData = async () => {
		if (!getConfig().flags.hasBasketUpsells) return;
		try {
			let payload;
			if (Basket.has_multi_basket) {
				payload = {
					multi_basket_items: Basket.multi_basket_items.map(({ restaurant, menu }) => ({
						menu,
						restaurant: {
							business_location_id: restaurant?.business_location_id,
							...(restaurant?.menu_id && { menu_id: restaurant.menu_id }),
						},
					})),
				};
			} else {
				const restaurant = Basket.getRestaurant();
				payload = {
					business_location_id: restaurant?.business_location_id,
					menu_id: Basket.getMenu(),
				};
			}
			const rawUpsellData = await api.getBasketUpsells(payload);
			this.setState({ rawUpsellData, upsellData: this.filterUpsellData(rawUpsellData) });
		} catch (err) { }
	};

	componentDidMount = () => {
		if (this.props.showOnlyItems) return;
		if (getConfig().flags.removeSidebar) {
			if (this.props.location.pathname == '/order-summary') {
				this.fetchUpsellData();
			}
		} else {
			this.fetchUpsellData();
		}
	};

	componentDidUpdate = (prevProps) => {
		if (prevProps.basketUpdated !== this.props.basketUpdated) {
			this.setState({ upsellData: this.filterUpsellData(this.state.rawUpsellData) });
		}
	};

	handleServiceChargeModal = (flag) => {
		this.setState({ serviceChargeModalOpen: flag });
	};

	drawSubItems = (basketItem = {} /*, basketItemIndex*/) => {
		const { selectedChoices } = basketItem;
		const basketInstance = this.props.basketInstance || Basket;
		const { profile } = this.props;
		if (selectedChoices && selectedChoices.length > 0) {
			return selectedChoices.map((choiceGroup, choiceGroupIndex) => {
				return (choiceGroup || []).map((choice, choiceIndex) => {
					const { sku } = choice;
					return (
						<IonRow className={choice.bundleModifier ? 'sub-item bundle-modifier-item' : 'sub-item'} key={makeKey(choiceGroupIndex, choiceIndex, sku)} /*onClick={ () => this.handleOrderItemClick(basketItem, basketItemIndex) }*/>
							<IonCol size="50px"></IonCol>
							<IonCol className="paddLR grow">
								{choice.quantity} x {Basket.getProductName(choice, profile)}
							</IonCol>
							<IonCol className="righted paddLR self-aligned">
								{basketInstance.calculateSubItemPrice(choice, choice.quantity) !== 0 ? basketInstance._calculateSubItemPrice(choice, choice.quantity) : null}
							</IonCol>
						</IonRow>
					);
				});
			});
		}
		return null;
	};
	drawSubItemsText = (basketItem = {} /*, basketItemIndex*/) => {
		const { selectedChoices } = basketItem;
		const basketInstance = this.props.basketInstance || Basket;
		const { profile } = this.props;
		if (selectedChoices && selectedChoices.length > 0) {
			return selectedChoices.map((choiceGroup, choiceGroupIndex) => {
				return (choiceGroup || []).map((choice, choiceIndex) => {
					const { sku } = choice;
					return (
						<div className={choice.bundleModifier ? 'sub-item modifier-item bundle-modifier-item' : 'sub-item modifier-item'} key={makeKey(choiceGroupIndex, choiceIndex, sku)} /*onClick={ () => this.handleOrderItemClick(basketItem, basketItemIndex) }*/>
							<NormalText className="paddLR grow">
								<SmallText>
									{choice.quantity} x {Basket.getProductName(choice, profile)}
								</SmallText>
							</NormalText>
							<NormalText className="righted paddLR self-aligned">
								<SmallText className='label-color'>{basketInstance.calculateSubItemPrice(choice, choice.quantity) !== 0 ? basketInstance._calculateSubItemPrice(choice, choice.quantity) : null}</SmallText>
							</NormalText>
						</div>
					);
				});
			});
		}
		return null;
	};
	selectServicePercentage(serviceCharge) {
		const basketInstance = this.props.basketInstance || Basket;
		const serviceChargeApplied = basketInstance.getServicePercentage();
		return serviceCharge === serviceChargeApplied;
	}
	customServiceChargeSelected = () => {
		return !Basket.service_percentage && Basket.service_charge > 0
	}
	drawServiceChargeBox = (__, service_charge, basketInstance) => {
		return (
			<IonList className="service-charge-box-wrapper box-wrapper centered">
				<div className='service-charge-title'>
					<StrongText>{__('Optional service charge?')}</StrongText>
					<StrongText>{basketInstance.getServiceChargeValue() > 0 ? basketInstance.getFormatedServiceChargeValue() : basketInstance.getServiceCharge(true)}</StrongText>
				</div>
				<div className="service-charge-values">
					{service_charge.map((item) => {
						return (
							<IonButton
								className={this.selectServicePercentage(item) && 'is-active'}
								key={item + 'service_charge'}
								expand="block"
								color="primary"
								onClick={(e) => {
									if (this.state.serviceChargeAmount) {
										this.setState({ serviceChargeAmount: null })
									}
									e.stopPropagation();
									document.querySelectorAll('.service-charge-values ion-button').forEach((el) => el.classList.remove('is-active'));
									e.target.classList.add('is-active');
									this.selectServicePercentage(item) ? basketInstance.setServicePercentage(0) : basketInstance.setServicePercentage(item)
								}}
							>
								{item === 0 ? <NormalText>{__('None')} </NormalText> : <NormalText>{item}% </NormalText>}
							</IonButton>
						);
					})}
					<IonButton
						className={this.customServiceChargeSelected() && 'is-active'}
						expand="block"
						color="primary"
						onClick={() => this.setState({ serviceChargeModalOpen: true, serviceChargeBoxModalOpen: false })}>
						<NormalText>{__("Custom")}</NormalText>
					</IonButton>
				</div>



			</IonList>
		);
	};
	setCustomServiceCharge = (value) => {
		if (value >= 0) {
			this.setState({ serviceChargeAmount: value, customAmountErrorVisible: false });
		} else {
			this.setState({ customAmountErrorVisible: true, serviceChargeAmount: 0 });
		}
	};
	getOrderStatusColor = (val) => {
		const status = val.toUpperCase();
		let color = '';
		if (status === 'PREPARING' || status === 'ONWAY') {
			color = 'warning';
		} else if (status === 'COLLECTED' || status === 'READY' || status === 'DELIVERED') {
			color = 'success';
		} else if (status === 'FAILED' || status === 'PAYMENT FAILED') {
			color = 'danger';
		} else {
			color = 'gray';
		}
		return color;
	};
	selectMultiVenueRestaurant = (restaurant) => {
		Basket.setRestaurant(restaurant);
		if (Basket.order_type == 'collection') {
			const pickTime = moment.unix(Basket.collection_time).tz(getConfig().timezone).format('HH:mm');
			this.setState({ selectRestaurantsModalOpen: false }, () => {
				this.props.dispatch(
					getIkentooMenusForLocation(restaurant.business_location_id, {
						pickTime,
						json_time_selector: restaurant ? restaurant.json_time_selector : [],
					}),
				);
			});
		} else if (Basket.order_type == 'table') {
			this.setState({ selectRestaurantsModalOpen: false }, () => {
				this.props.dispatch(
					getIkentooMenusForLocation(restaurant.business_location_id, {
						pickTime: 'asap',
						json_time_selector: restaurant ? restaurant.table_json_time_selector : [],
					}),
				);
			});
		} else if (Basket.order_type == 'pick-up-at-counter') {
			this.setState({ selectRestaurantsModalOpen: false }, () => {
				this.props.dispatch(
					getIkentooMenusForLocation(
						restaurant.business_location_id,
						{
							pickTime: 'asap',
							json_time_selector: restaurant ? restaurant.pick_up_at_counter_json_time_selector : [],
						},
						false,
					),
				);
			});
		} else if (Basket.order_type == 'browse-menu') {
			this.setState({ selectRestaurantsModalOpen: false }, () => {
				this.props.dispatch(
					getIkentooMenusForLocation(
						restaurant.business_location_id,
						{
							pickTime: 'asap',
							json_time_selector: restaurant ? restaurant.browse_menu_json_time_selector : [],
						},
						restaurant.browse_menu_json_time_selector.length === 1 ? false : true,
					),
				);
			});
		} else if (Basket.order_type == 'charter-delivery') {
			const pickTime = moment.unix(Basket.collection_time).tz(getConfig().timezone).format('HH:mm');
			this.setState({ selectRestaurantsModalOpen: false }, () => {
				this.props.dispatch(
					getIkentooMenusForLocation(restaurant.business_location_id, {
						pickTime,
						json_time_selector: restaurant ? restaurant.charter_delivery_times_json : [],
					}),
				);
			});
		} else if (Basket.order_type == 'scheduled-delivery') {
			const pickTime = moment.unix(Basket.collection_time).tz(getConfig().timezone).format('HH:mm');
			this.setState({ selectRestaurantsModalOpen: false }, () => {
				this.props.dispatch(
					getIkentooMenusForLocation(restaurant.business_location_id, {
						pickTime,
						json_time_selector: [
							{
								menuId: restaurant?.active_menus.scheduled_delivery?.menu_id,
								availability: Object.keys(restaurant?.active_menus.scheduled_delivery?.slots).map((slot) => {
									if (restaurant?.active_menus.scheduled_delivery?.slots[slot].start_time) {
										return {
											d: weekdays[slot],
											start: restaurant?.active_menus.scheduled_delivery?.slots[slot].start_time,
											end: restaurant?.active_menus.scheduled_delivery?.slots[slot].end_time,
										};
									}
								}),
							},
						],
					}),
				);
			});
		} else if (Basket.order_type == 'scheduled-collection') {
			const pickTime = moment.unix(Basket.collection_time).tz(getConfig().timezone).format('HH:mm');
			this.setState({ selectRestaurantsModalOpen: false }, () => {
				this.props.dispatch(
					getIkentooMenusForLocation(restaurant.business_location_id, {
						pickTime,
						json_time_selector: [
							{
								menuId: restaurant?.active_menus.scheduled_collection?.menu_id,
								availability: Object.keys(restaurant?.active_menus.scheduled_collection?.slots).map((slot) => {
									if (restaurant?.active_menus.scheduled_collection?.slots[slot].start_time) {
										return {
											d: weekdays[slot],
											start: restaurant?.active_menus.scheduled_collection?.slots[slot].start_time,
											end: restaurant?.active_menus.scheduled_collection?.slots[slot].end_time,
										};
									}
								}),
							},
						],
					}),
				);
			});
		}
	};
	finaliseTableOrder = () => {
		this.props.dispatch(setCommonProp('serviceChargeBoxAlertOpen', false));

		let data = Basket.has_multi_basket
			? deepCopy(Basket.multi_basket_items)
			: [
				{
					restaurant: { business_location_id: Basket.getRestaurant()?.business_location_id },
					items: Basket.items,
				},
			];
		const additionalData = Basket.getAdditionalTaxData();
		if (additionalData) {
			data.push(additionalData);
		}
		this.props.dispatch({ type: GET_TAX, data, includeAll: true });
	};
	calculateOrderPoints = (points) => {
		let calculatedPoints = Math.floor((Basket.getTotal() + Basket.getAppliedGiftCardsValue()) * points);
		return calculatedPoints.toFixed(0);
	};
	getUpsellEntries = (restaurant = null) => {
		const { upsellData } = this.state;
		if (!Basket.has_multi_basket) return upsellData.flat().map((item) => ({ item, restaurant: null }));
		return upsellData
			.filter((el) => !restaurant || el.restaurant == restaurant.business_location_id)
			.flatMap((el) => {
				const upsellRestaurant = Basket.multi_basket_items.find((order) => order.restaurant.business_location_id == el.restaurant)?.restaurant ?? null;
				return (el.items ?? []).flat().map((item) => ({ item, restaurant: upsellRestaurant }));
			});
	};
	renderUpsellSlider = (entries) => {
		const { profile, __ } = this.props;
		if (!entries || entries.length === 0) return null;
		const container = isWebConfig() ? document.querySelector(getConfig().flags.removeSidebar ? '.order-summary-amount' : '.checkout') : null;
		const containerStyle = container && getComputedStyle(container);
		const containerWidth = container ? container.clientWidth - parseFloat(containerStyle.paddingLeft) - parseFloat(containerStyle.paddingRight) : window.innerWidth - 32;
		const slidesPerView = containerWidth / 136;
		const paginationClass = 'basket-upsell-pagination';
		return (
			<div className='basket-upsell'>
				<StrongText className='block text-to-update'>{__('You might also like')}</StrongText>
				<Spacer size={1} />
				<div className='basket-upsell-data'>
					<Slider
						settings={{
							slidesPerView,
							spaceBetween: 10,
							pagination: { el: `.${paginationClass}`, clickable: true },
						}}
					>
						{entries.map(({ item: upsellItem, restaurant }, idx) => {
							const placeholderImage = restaurant?.menu_item_placeholder_image || Basket.getRestaurant()?.menu_item_placeholder_image || this.props.clientProfile.logo_image;
							let upsellImage = upsellItem.itemRichData?.squareImageUrl || '';
							if (upsellImage && upsellImage.indexOf('http://') !== -1) {
								upsellImage = upsellImage.replace(/http:\/\//g, 'https://');
							}
							const addToBasket = upsellItem?.[`@type`] == 'menuItem'
							return (
								<Slide key={`${restaurant?.business_location_id ?? 'basket'}-${upsellItem.sku || idx}`}>
									<div
										className="upsell-item"
										onClick={() => {
											if (addToBasket) {
												Basket.addToBasket({ item: upsellItem, quantity: 1, selectedChoices: [], instructions: '' }, restaurant);
											} else if (isWebConfig()) {
												this.setState({ selectedUpsellItem: upsellItem, selectedUpsellRestaurant: restaurant });
											} else {
												forwardTo('/item-details', { ...upsellItem, fromUpsell: true, selectedUpsellRestaurant: restaurant });
											}
										}}
									>
										<img
											className="upsell-item-image"
											src={upsellImage || placeholderImage}
											alt={Basket.getProductName(upsellItem, profile)}
										/>
										<div className='upsell-description'>
											<StrongText className="block">{Basket.getProductName(upsellItem, profile)}</StrongText>
											<div>
												<SmallText className='upsell-price'>{Basket.formatPrice(upsellItem.productPrice, true)}</SmallText>
											</div>
										</div>
									</div>
								</Slide>
							);
						})}
						<div className={`swiper-pagination ${paginationClass}`}></div>
					</Slider>
				</div>
			</div>
		);
	};
	render() {
		const { handleOrderItemClick, __, history, profile, showAddItems, dispatch, isRemoveVoucherModalOpen, taxContentLoading, showOnlyItems, showOnlyAmount, showItemModal } = this.props;
		const { showRemoveItemAlert, removeItemAlertFunction } = this.state;
		const basketInstance = this.props.basketInstance || Basket;
		const type = this.props.type || 'order';
		const orderType = basketInstance.getOrderType();
		const appliedPoints = basketInstance.getAppliedPoints();
		const deliveryPrice = basketInstance.getDeliveryPrice();
		const deliveryPriceUnformated = basketInstance._getDeliveryPrice();
		const { serviceChargeModalOpen, removeItem } = this.state;
		const appliedVoucher = basketInstance.getAppliedVoucher();
		const appliedGiftCards = basketInstance.getAppliedGiftCards();

		let location = history && history.location && history.location.pathname === '/history-details' ? true : false;
		let service_charge_original;
		let service_charge = [];
		if (!basketInstance.service_charge_value && basketInstance.service_charge_value !== 0 && getConfig().general.service_charge_modules?.includes(Basket.order_type)) {
			if (basketInstance.getRestaurantServiceCharge()) {
				service_charge_original = basketInstance.getRestaurantServiceCharge();
			} else {
				service_charge_original =
					typeof getConfig().general.defaultServiceCharge == 'string' ? JSON.stringify(getConfig().general.defaultServiceCharge) : getConfig().general.defaultServiceCharge;
			}
			service_charge = service_charge_original.map((el) => Number((el * 100).toFixed(2)));
		}
		const isAlreadyCreatedOrder = type === 'orderHistory';
		const points_value_percentage = getPointsValuePercentage(this.props.profile)



		return (
			<>


				{showOnlyItems ? <>
					<Title className='page-title-centered'>{this.props.contentTitle || __('Your order')}</Title>
					<div className='basket-order-content'>
						{Basket.has_multi_basket ? <>
							{basketInstance.multi_basket_items?.map((order, basketOrderContentIndex) => (
								<React.Fragment key={`order_${basketOrderContentIndex}`}>
									<Subtitle className="order-summary-items-wrapper text-to-update">{order.restaurant.name}</Subtitle>

									<div
										className={`${taxContentLoading ? 'unclickable' : ''} basket-items-wrapper basket-items-wrapper-with-modifiers ${isAlreadyCreatedOrder ? `basket-items-wrapper-${this.getOrderStatusColor(order.status)}` : ''
											} `}
									>
										{order.items.map((basketItem, basketItemIndex) => {
											const { quantity, item, instructions, selectedChoices } = basketItem;
											let image = item.itemRichData && item.itemRichData.squareImageUrl ? item.itemRichData.squareImageUrl : '';
											if (image && image.indexOf('http://') !== -1) {
												image = image.replace(/http:\/\//g, 'https://');
											}
											return (
												<React.Fragment key={`basket-item_${basketItemIndex}`}>
													<div className='box-content'>
														<div >
															{!getConfig().flags.removeMenuImages &&
																<div
																	className="order-item-image"
																	style={
																		image && image !== ''
																			? { backgroundImage: `url(${image})` }
																			: {
																				backgroundSize: 'contain',
																				backgroundImage: `url(${order.restaurant?.menu_item_placeholder_image || this.props.clientProfile.logo_image})`,
																			}
																	}
																/>
															}
															<div className="item-content-wrapper flex-justify-between flex-row-wrapper">
																<div>
																	<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 'var(--spacer-0)' }}>
																		<StrongText className="block text-to-update">{Basket.getProductName(item, profile)}</StrongText>
																	</div>
																	{basketItem.instructions !== '' && (
																		<>
																			<Spacer size={2} />
																			<SmallText className="block">{`${__('Instructions')}: ${basketItem.instructions}`} </SmallText>
																		</>
																	)}
																</div>
																<div className="item-content-actions flex-justify-between flex-col-wrapper flex-align-center">
																	<div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>

																		<Incrementer
																			onUpdate={(val) => {
																				if (handleOrderItemClick) {
																					handleOrderItemClick(basketItem, basketItemIndex, val, order.restaurant.id);
																				}
																			}}
																			quantity={quantity}
																			step={1}
																			allowNegative={false}
																			minLimit={1}
																			allowInput
																		>
																		</Incrementer>
																		{handleOrderItemClick && (
																			<IonIcon color='primary' className='pointer' icon={trashBinOutline} onClick={() => { this.setState({ showRemoveItemAlert: true, removeItemAlertFunction: () => handleOrderItemClick(basketItem, basketItemIndex, 0, order.restaurant.id) }) }} />
																		)}
																	</div>
																	<StrongText>

																		{basketInstance.formatPrice(basketInstance.calculateItemPrice(basketItem, false))}
																	</StrongText>
																</div>
															</div>
														</div>
														{selectedChoices && selectedChoices.flat().length > 0 && (
															<>
																<Spacer size={3} />
																<SmallText>{__('Options:')}</SmallText>
																{selectedChoices.map((choiceGroup, choiceGroupIndex) => (
																	<React.Fragment key={`group-${choiceGroupIndex}`}>
																		{(choiceGroup || []).map((choice, choiceIndex) => {
																			const { sku } = choice;
																			return (
																				<div className={choice.bundleModifier ? "sub-item modifier-item custom-bullet bundle-modifier-item" : "sub-item modifier-item custom-bullet"} key={makeKey(choiceGroupIndex, choiceIndex, sku)}>
																					<NormalText className="paddLR grow">
																						<SmallText>
																							{choice.quantity} x {Basket.getProductName(choice, profile)}
																						</SmallText>
																					</NormalText>
																					<NormalText className="righted paddLR self-aligned">
																						<SmallText >
																							{basketInstance.calculateSubItemPrice(choice, choice.quantity) !== 0
																								? basketInstance._calculateSubItemPrice(choice, choice.quantity)
																								: null}
																						</SmallText>
																					</NormalText>
																				</div>
																			);
																		})}
																	</React.Fragment>
																))}
															</>
														)}

													</div>

												</React.Fragment>
											);
										})}
										< Spacer size={3} />

									</div>
								</React.Fragment>
							))}
						</> : <>


							<div className={`basket-items-wrapper  basket-items-wrapper-with-modifiers ${taxContentLoading ? 'unclickable' : ''}`}>
								{basketInstance.getItems().map((basketItem, basketItemIndex) => {
									const { quantity, item, instructions, selectedChoices } = basketItem;
									let image = item.itemRichData && item.itemRichData.squareImageUrl ? item.itemRichData.squareImageUrl : '';
									if (image && image.indexOf('http://') !== -1) {
										image = image.replace(/http:\/\//g, 'https://');
									}
									return (
										<React.Fragment key={`basket-item_${basketItemIndex}`}>
											<div className='box-content'>
												<div >
													{!getConfig().flags.removeMenuImages &&

														<div
															className="order-item-image"
															style={
																image && image !== ''
																	? { backgroundImage: `url(${image})` }
																	: {
																		backgroundSize: 'contain',
																		backgroundImage: `url(${Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.restaurantMenuItemImage ?? this.props.clientProfile.logo_image})`,
																	}
															}
														/>}
													<div className="item-content-wrapper flex-justify-between flex-row-wrapper">
														<div>
															<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 'var(--spacer-0)' }}>
																<StrongText className="block text-to-update">{Basket.getProductName(item, profile)}</StrongText>
															</div>


															{basketItem.instructions && basketItem.instructions !== '' && (
																<>
																	<Spacer size={2} />
																	<SmallText className="block">{`${__('Instructions')}: ${basketItem.instructions}`} </SmallText>
																</>
															)}
														</div>
														<div className="item-content-actions flex-justify-between flex-col-wrapper flex-align-center">
															<div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
																<Incrementer
																	onUpdate={(val) => {
																		if (handleOrderItemClick) {
																			handleOrderItemClick(basketItem, basketItemIndex, val);
																		}
																	}}
																	quantity={quantity}
																	step={1}
																	allowNegative={false}
																	minLimit={1}
																	allowInput


																>
																</Incrementer>
																{handleOrderItemClick && (
																	<IonIcon color='primary' className='pointer' icon={trashBinOutline} onClick={() => { this.setState({ showRemoveItemAlert: true, removeItemAlertFunction: () => handleOrderItemClick(basketItem, basketItemIndex, 0) }) }} />
																)}
															</div>
															<StrongText>
																{basketInstance.calculateItemPriceByIndex(basketItemIndex, true) > 0 ? basketInstance._calculateItemPriceByIndex(basketItemIndex, true) : null}
															</StrongText>
														</div>

													</div>

												</div>
												{selectedChoices && selectedChoices.flat().length > 0 && (
													<>
														<Spacer size={3} />
														<SmallText>{__('Options:')}</SmallText>
														{selectedChoices.map((choiceGroup, choiceGroupIndex) => (
															<React.Fragment key={`group-${choiceGroupIndex}`}>
																{(choiceGroup || []).map((choice, choiceIndex) => {
																	const { sku } = choice;
																	return (
																		<div className={choice.bundleModifier ? "sub-item modifier-item custom-bullet bundle-modifier-item" : "sub-item modifier-item custom-bullet"} key={makeKey(choiceGroupIndex, choiceIndex, sku)}>
																			<NormalText className="paddLR grow">
																				<SmallText>
																					{choice.quantity} x {Basket.getProductName(choice, profile)}
																				</SmallText>
																			</NormalText>
																			<NormalText className="righted paddLR self-aligned">
																				<SmallText >
																					{basketInstance.calculateSubItemPrice(choice, choice.quantity) !== 0
																						? basketInstance._calculateSubItemPrice(choice, choice.quantity)
																						: null}
																				</SmallText>
																			</NormalText>
																		</div>
																	);
																})}
															</React.Fragment>
														))}
													</>
												)}

											</div>
										</React.Fragment>
									);
								})}
								<Spacer size={3} />

							</div>
						</>}
					</div>
					<div>

						<IonButton disabled={Basket.itemsCount() == 0} onClick={() => forwardTo('/order-summary')} fill='solid' color='primary' className='button-uppercase order-basket-btn'>
							<NormalText class='order-basket-count'>{Basket.itemsCountAll()}</NormalText>
							<StrongText>{__('Go to checkout')}</StrongText>
							<NormalText>{Basket.calculateItemsTotal()}</NormalText>

						</IonButton>
					</div>

				</> :


					<>

						{showOnlyAmount ? <>
							<IonGrid className="box-content order-content-wrapper paddL">
								{!basketInstance.is_gift && !basketInstance.is_event ? (
									<IonRow>
										<IonCol>
											<IonCol ><StrongText className='text-to-update'>{__('Items total')}</StrongText></IonCol>
										</IonCol>
										<IonCol className="righted bold">{basketInstance.calculateItemsTotal()}</IonCol>
									</IonRow>
								) : null}
							</IonGrid>
							{this.renderUpsellSlider(this.getUpsellEntries())}
							{isAlreadyCreatedOrder &&
								basketInstance.getServiceChargeValue() > 0 &&
								<IonGrid className="box-content order-content-wrapper paddL">
									<div key="service_charge" className="basket-item-wrapper">
										<IonRow className="basket-item-service-charge-row service-charge-item" onClick={() => isAlreadyCreatedOrder ? () => { } : this.setState({ removeServiceChargeModal: true })}>
											<>
												<IonCol className="paddLR grow ">
													<StrongText className='text-to-update'>
														{__('Service charge')}
														{!isAlreadyCreatedOrder &&
															<>
																{basketInstance.service_charge_value ? (
																	<>{basketInstance.service_percentage !== 0 && ` ${basketInstance._getServicePercentage()}`}</>
																) : (
																	<>{basketInstance.service_percentage !== false && ` ${basketInstance._getServicePercentage()}`}</>
																)}
															</>}
													</StrongText>

												</IonCol>
												<IonCol className="righted paddLR self-center bold">
													{basketInstance.getServiceChargeValue() > 0 ? basketInstance.getFormatedServiceChargeValue() : basketInstance.getServiceCharge(true)}
												</IonCol>
											</>
										</IonRow>
										<Modal
											alertType
											actionLabel={__('Yes')}
											action={() => this.setState({ removeServiceChargeModal: false }, () => {
												basketInstance.setServiceCharge(0)
												basketInstance.setServicePercentage(0)

											})}
											isOpen={this.state.removeServiceChargeModal}
											onDidDismiss={() => this.setState({ removeServiceChargeModal: false })}
											noContent={true}
										>
											<StrongText>{__('Do you want to remove service charge') + ' ?'}</StrongText>
										</Modal>
									</div>
								</IonGrid>
							}
							{!isAlreadyCreatedOrder &&
								<>
									{((basketInstance.service_percentage > 0 || basketInstance.service_percentage === false) &&
										getConfig().general.service_charge_modules?.includes(Basket.order_type) &&
										getConfig().general.hasServiceCharge) &&
										getConfig().general.serviceChargeBoxHidden &&

										<IonGrid className="box-content order-content-wrapper paddL">
											<div key="service_charge" className="basket-item-wrapper">
												<IonRow className="basket-item-service-charge-row service-charge-item" onClick={() => this.setState({ serviceChargeBoxModalOpen: true })}>
													<>
														<IonCol className="paddLR grow ">
															<StrongText className='text-to-update'>
																{__('Service charge')}
																{basketInstance.service_charge_value ? (
																	<>{basketInstance.service_percentage !== 0 && ` ${basketInstance._getServicePercentage()}`}</>
																) : (
																	<>{basketInstance.service_percentage !== false && ` ${basketInstance._getServicePercentage()}`}</>
																)}

															</StrongText>

														</IonCol>
														<IonCol className="righted paddLR self-center bold">
															{basketInstance.getServiceChargeValue() > 0 ? basketInstance.getFormatedServiceChargeValue() : basketInstance.getServiceCharge(true)}
														</IonCol>
													</>
												</IonRow>

											</div>
										</IonGrid>
									}
								</>}

							{deliveryPriceUnformated > 0 ? (
								<IonGrid className="box-content order-content-wrapper paddL">
									<IonRow>
										<IonCol className="paddLR grow">
											<StrongText>
												{basketInstance.getRestaurant()?.delivery_charge_in_percent && basketInstance.getRestaurantDeliveryPrice()
													? `${basketInstance.getRestaurantDeliveryPrice()}% `
													: null}
												{__('Delivery Charge')}
											</StrongText>

										</IonCol>
										<IonCol className="righted paddLR bold">
											{deliveryPrice}
										</IonCol>
									</IonRow>
								</IonGrid>

							) : null}
							{basketInstance.process_fee_value > 0 && (
								<IonGrid className="box-content order-content-wrapper paddL">


									<IonRow className="">
										<>
											<IonCol className="paddLR grow ">
												<StrongText>
													{`${__('Processing fee')} ${Basket.processing_fee_description ? `${Basket.processing_fee_description}` : ''}`}


												</StrongText>

											</IonCol>
											<IonCol className="righted paddLR self-center bold ">{basketInstance.getProcessingFee()}</IonCol>
										</>
									</IonRow>
								</IonGrid>

							)}

							{basketInstance.discount && (
								<IonGrid className="box-content order-content-wrapper paddL">
									<IonRow>
										<IonCol className="paddLR grow">{basketInstance.discount.title}</IonCol>
										<IonCol className="righted paddLR bold">-{basketInstance.formatPrice(basketInstance.calculateMembershipDiscount())}</IonCol>
									</IonRow>
								</IonGrid>

							)}
							{basketInstance.getTotalTaxBreakdown() > 0 && (
								<>
									<StrongText style={{ margin: 'var(--spacer-2) 0' }}>{__('Taxes')}</StrongText>
									<IonGrid className={`box-content order-content-wrapper paddL `}>
										{basketInstance.getTaxDataForDisplay().map((taxLine, taxIndex) => (
											<div key={`tax_${taxIndex}`} style={{ position: 'relative' }}>
												<IonRow>
													<IonCol className="paddLR grow strong-text">{taxLine.tax_name}</IonCol>
													<IonCol className="righted paddLR self-center strong-text">{basketInstance.formatPrice(taxLine.tax_amount)}</IonCol>
												</IonRow>
											</div>
										))}
										<IonRow>
											<IonCol className="paddLR grow strong-text">{__('Total taxes')}</IonCol>
											<IonCol className="righted paddLR self-center strong-text">{basketInstance.formatPrice(basketInstance.getTotalTaxBreakdown(), true)}</IonCol>
										</IonRow>
									</IonGrid>
								</>
							)}

							{this.props.serviceChargeBoxAlertOpen && (
								<Modal backdropDismiss={false} className="modal-type-alert" isOpen={this.props.serviceChargeBoxAlertOpen}>
									{this.drawServiceChargeBox(__, service_charge, basketInstance)}
									<Spacer size={5} />
									<div className='alert-button-group'>
										<IonButton
											className='button-uppercase'
											color="secondary "
											onClick={() => {
												if (Basket._getServiceCharge() != 0) {
													basketInstance.setServicePercentage(0);

												}
												this.props.dispatch(setCommonProp('serviceChargeBoxAlertOpen', false));
												this.props.dispatch(setCommonProp('serviceChargeBoxAlertAction', false));
												if (this.props.serviceChargeBoxAlertAction) {
													this.props.serviceChargeBoxAlertAction()

												} else {
													this.finaliseTableOrder();

												}
											}}
										>
											{__('Not this time')}
										</IonButton>
										<IonButton
											className='button-uppercase'
											expand="block"
											color="primary"
											onClick={() => {
												this.props.dispatch(setCommonProp('serviceChargeBoxAlertOpen', false));
												this.props.dispatch(setCommonProp('serviceChargeBoxAlertAction', false));
												if (this.props.serviceChargeBoxAlertAction) {
													this.props.serviceChargeBoxAlertAction()

												} else {
													this.finaliseTableOrder();

												}
											}}
										>
											{__('Done')}
										</IonButton>
									</div>


								</Modal>
							)}
							<IonGrid class="box-wrapper order-content-wrapper">
								{isAlreadyCreatedOrder && isDefined(appliedPoints) && appliedPoints > 0 ? (
									<IonRow>
										<IonCol className="paddLR grow bold">
											<StrongText className='text-to-update'>
												{`${appliedPoints} ${__('points redeemed')}`}

											</StrongText>
										</IonCol>
										<IonCol className="righted paddLR bold">{basketInstance._calculatePointsAppliedPrice(null, true)}</IonCol>
									</IonRow>
								) : null}
								{isAlreadyCreatedOrder && appliedGiftCards &&
									basketInstance.getAppliedGiftCardsValue() > 0 &&
									appliedGiftCards
										.filter((card) => card.value > 0)
										.map((card) => {
											return (
												<IonRow key={card.id}>
													<IonCol size='7' className="paddLR grow"><StrongText className='text-to-update'>{`${__(card?.isEventCard ? 'Event card' : card?.isTopUpCard ? 'Top Up card' : 'Gift card')} ${getGiftCardNumber(card)}`}</StrongText> </IonCol>
													<IonCol className="righted paddLR bold">{basketInstance.formatPrice(card.value * -1)}</IonCol>
												</IonRow>
											);
										})}
								{appliedVoucher &&
									appliedVoucher.length > 0 &&
									appliedVoucher.map((voucher) => {
										let voucherName = voucher.name;
										if (voucher && voucher.reward && voucher.reward.name) {
											voucherName = voucher.reward.name;
										}
										return (
											<>
												<IonRow key={voucher.id} onClick={() => (isAlreadyCreatedOrder ? null : dispatch(setModal('isRemoveVoucherModalOpen', true)))}>
													<IonCol className="paddLR grow"><StrongText className='text-to-update'>{isAlreadyCreatedOrder ? __('Loyalty voucher applied') : __(voucherName)}</StrongText> </IonCol>
													<IonCol size='4' className="righted paddLR bold">{basketInstance._calculateAppliedVocuhersPrice(true, null)}</IonCol>
												</IonRow>
												<Modal
													alertType
													actionLabel={__('Yes')}
													action={() => dispatch(removeVoucher(voucher))}
													isOpen={!!isRemoveVoucherModalOpen}
													onDidDismiss={() => dispatch(setModal('isRemoveVoucherModalOpen', false))}
													noContent={true}
												>
													<StrongText>{__('Do you want to remove voucher') + '?'}</StrongText>
												</Modal>
											</>
										);
									})}

							</IonGrid>
							{(isAlreadyCreatedOrder || this.props.taxCalculated || !getConfig().flags.hasTaxBreakdown) && (

								<IonGrid class="box-wrapper order-content-wrapper order-content-total">
									<IonRow>
										<IonCol>
											<IonCol><StrongText className=" text-to-update">{isAlreadyCreatedOrder ? __('Total') : __('Total to pay')}</StrongText></IonCol>
										</IonCol>
										<IonCol className="righted  bold">{basketInstance._getTotal(true)}</IonCol>
									</IonRow>

									{!getConfig().flags.removePointsEarningFromCheckout && (points_value_percentage > 0 && !isAlreadyCreatedOrder && this.calculateOrderPoints(points_value_percentage) > 0) &&
										<IonRow style={{ gap: 'var(--spacer-0)', alignItems: 'flex-start', display: 'grid', gridTemplateColumns: 'auto 1fr', border: 'none', paddingTop: 0, height: 'auto' }}>
											<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
												<path d="M7.50016 18.3337H15.0002C15.6918 18.3337 16.2835 17.917 16.5335 17.317L19.0502 11.442C19.1252 11.2503 19.1668 11.0503 19.1668 10.8337V9.16699C19.1668 8.25033 18.4168 7.50033 17.5002 7.50033H12.2418L13.0335 3.69199L13.0585 3.42533C13.0585 3.08366 12.9168 2.76699 12.6918 2.54199L11.8085 1.66699L6.31683 7.15866C6.01683 7.45866 5.8335 7.87533 5.8335 8.33366V16.667C5.8335 17.5837 6.5835 18.3337 7.50016 18.3337ZM7.50016 8.33366L11.1168 4.71699L10.0002 9.16699H17.5002V10.8337L15.0002 16.667H7.50016V8.33366ZM0.833496 8.33366H4.16683V18.3337H0.833496V8.33366Z" fill="var(--ion-color-success)" />
											</svg>
											<NormalText className='success-color'>{`${__('You will earn')} ${this.calculateOrderPoints(points_value_percentage)} ${__('loyalty points on this order')}`}</NormalText>
										</IonRow>
									}
								</IonGrid>
							)}
							{basketInstance.service_percentage === 0 &&
								getConfig().general.service_charge_modules?.includes(Basket.order_type) &&
								getConfig().general.hasServiceCharge &&
								getConfig().general.serviceChargeBoxHidden &&
								basketInstance.getServiceChargeValue() === null ? (
								<>
									<div key="service_charge" className="basket-item-wrapper">
										<IonButton
											expand="block"
											color='secondary'
											className="link  basket-item-service-charge-row"
											onClick={() => this.setState({ serviceChargeBoxModalOpen: true })}
										>
											{__('Add a service charge')}
										</IonButton>
									</div>
								</>
							) : null}

							{getConfig().general.hasServiceCharge &&
								!basketInstance.service_charge_value &&
								basketInstance.service_charge_value !== 0 &&
								getConfig().general.service_charge_modules?.includes(Basket.order_type) && (
									<>
										{!getConfig().general.serviceChargeBoxHidden ? (
											<>{this.drawServiceChargeBox(__, service_charge, basketInstance)}</>
										) : (
											<>
												<Modal
													className="modal-type-alert"
													isOpen={this.state.serviceChargeBoxModalOpen}
													onDidDismiss={() => this.setState({ serviceChargeBoxModalOpen: false })}
												>
													<Spacer size={5} />
													{this.drawServiceChargeBox(__, service_charge, basketInstance)}
													<Spacer size={5} />
													<div className='alert-button-group'>
														<IonButton
															className='button-uppercase'
															color="secondary "
															onClick={() => {
																basketInstance.setServicePercentage(0);
																this.setState({ serviceChargeBoxModalOpen: false });
															}}
														>
															{__('Not this time')}
														</IonButton>
														<IonButton
															className='button-uppercase'
															expand="block"
															color="primary"
															onClick={() => {
																this.setState({ serviceChargeBoxModalOpen: false });
															}}
														>
															{__('Done')}
														</IonButton>

													</div>
												</Modal>
											</>
										)}


									</>
								)}
							{getConfig()?.customExternalLinks?.checkout &&
								<>
									<Spacer size={3} />
									<IonButton
										onClick={() => {
											openExternalLink(getConfig().customExternalLinks.checkout?.url)
										}}
										color="secondary"
										className="link "
									>
										{__(getConfig().customExternalLinks.checkout?.title)}
									</IonButton>
								</>
							}
							{getConfig().general.allergenList &&
								<>

									<CheckoutAllergens allergens={basketInstance?.additional_data?.allergen_list} isAlreadyCreatedOrder={isAlreadyCreatedOrder} allergenError={this.props.allergenError} />
								</>
							}
							<Modal className="modal-type-alert" isOpen={serviceChargeModalOpen} onDidDismiss={() => this.handleServiceChargeModal(false)}>
								<StrongText className='block text-to-update'>{__('Add custom amount')}</StrongText>
								<Spacer size={5} />
								<IonItem lines="none" className="input-field-wrapper input-field-wrapper-with-floating-text ">
									<NormalText className='input-field-floating-text label-color'>{Basket.getCurrency().label}</NormalText>
									<IonInput value={this.state.serviceChargeAmount} clearInput onIonInput={(e) => this.setCustomServiceCharge(e.target.value)} type="number" pattern="number" inputmode="number"></IonInput>
								</IonItem>

								{this.state.customAmountErrorVisible && (
									<>
										<SmallText className="danger-color">{__('Value can not be negative')}</SmallText>
									</>
								)}
								<Spacer size={5} />
								<div className='alert-button-group'>
									<IonButton
										className='button-uppercase'
										expand="block"
										color={'secondary'}
										onClick={() => {
											this.handleServiceChargeModal(false)
										}}
									>
										{__('Cancel')}
									</IonButton>
									<IonButton
										className='button-uppercase'
										expand="block"
										onClick={() => {
											basketInstance.setServiceCharge(this.state.serviceChargeAmount);
											this.setState({ serviceChargeModalOpen: false });
										}}
										disabled={!this.state.serviceChargeAmount}
									>
										{__('Done')}
									</IonButton>
								</div>

							</Modal>
						</> : <>
							{basketInstance.has_multi_basket && !basketInstance.is_gift && !basketInstance.is_event ? (
								<>
									{basketInstance.multi_basket_items?.map((order, basketOrderContentIndex) => (
										<React.Fragment key={`order_${basketOrderContentIndex}`}>
											<Spacer size={2} />
											<StrongText className="order-summary-items-wrapper text-to-update">{`${__('Your order')} ${order.restaurant.name}`}</StrongText>
											{isAlreadyCreatedOrder && (
												<div className={`restautant-order-status restautant-order-status-${this.getOrderStatusColor(order.status)}`}>
													<NormalText>{__(order.status)}</NormalText>
												</div>
											)}
											<div
												className={`${taxContentLoading ? 'unclickable' : ''} basket-items-wrapper  ${isAlreadyCreatedOrder ? `basket-items-wrapper-${this.getOrderStatusColor(order.status)}` : ''
													} `}
											>
												{showAddItems && (
													<div className="add-items-button-wrapper">
														<IonButton
															onClick={() => this.selectMultiVenueRestaurant(order.restaurant)}
															size="small"
															color="secondary"
															className="add-items-btn link"
														>
															{__('Order more')}
														</IonButton>
													</div>
												)}

												{order.items.map((basketItem, basketItemIndex) => {
													const { quantity, item, instructions } = basketItem;
													let image = item.itemRichData && item.itemRichData.squareImageUrl ? item.itemRichData.squareImageUrl : '';
													if (image && image.indexOf('http://') !== -1) {
														image = image.replace(/http:\/\//g, 'https://');
													}
													return (
														<div className="box-content">
															{!getConfig().flags.removeMenuImages &&

																<div
																	className="order-item-image"
																	style={
																		image && image !== ''
																			? { backgroundImage: `url(${image})` }
																			: {
																				backgroundSize: 'contain',
																				backgroundImage: `url(${order.restaurant?.menu_item_placeholder_image || this.props.clientProfile.logo_image})`,
																			}
																	}
																/>}
															<div className="item-content-wrapper flex-justify-between flex-row-wrapper">
																<div>
																	<div style={{ display: 'grid', gridAutoFlow: 'column', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 'var(--spacer-0)' }}>
																		<StrongText className="block text-to-update">
																			{`${isAlreadyCreatedOrder ? `${quantity}x ` : ''}${Basket.getProductName(item, profile)}`}</StrongText>
																		{handleOrderItemClick && (
																			<IonIcon className='pointer' icon={closeOutline} onClick={() => { this.setState({ showRemoveItemAlert: true, removeItemAlertFunction: () => handleOrderItemClick(basketItem, basketItemIndex, 0, order.restaurant.id) }) }} />
																		)}
																	</div>
																	{this.drawSubItemsText(basketItem, basketItemIndex)}
																	{basketItem.instructions !== '' && (
																		<>
																			<Spacer size={2} />
																			<SmallText className="block">{`${__('Instructions')}: ${basketItem.instructions}`} </SmallText>
																		</>
																	)}
																</div>
																<div className="item-content-actions flex-justify-between flex-col-wrapper flex-align-center">
																	<Incrementer
																		onUpdate={(val) => {
																			if (handleOrderItemClick) {
																				handleOrderItemClick(basketItem, basketItemIndex, val, order.restaurant.id);
																			}
																		}}
																		quantity={quantity}
																		step={1}
																		allowNegative={false}
																		minLimit={1}
																	>
																		<StrongText className="bold primary-color">{quantity}</StrongText>
																	</Incrementer>
																	<StrongText>

																		{basketInstance.formatPrice(basketInstance.calculateItemPrice(basketItem, false))}
																	</StrongText>
																</div>
															</div>
														</div>
													);
												})}
											</div>
										</React.Fragment>
									))}
								</>
							) : (
								<>
									<StrongText className=" order-summary-items-wrapper text-to-update">{__('Your order')}</StrongText>

									<div className={`basket-items-wrapper ${taxContentLoading ? 'unclickable' : ''}`}>
										<div className="add-items-button-wrapper">
											{showAddItems ? (
												<IonButton size="small" color="secondary" className="add-items-btn link " onClick={() => forwardTo('/order')}>
													{__('Add more items')}
												</IonButton>
											) : null}
										</div>

										{basketInstance.getItems().map((basketItem, basketItemIndex) => {
											const { quantity, item, instructions } = basketItem;
											let image = item.itemRichData && item.itemRichData.squareImageUrl ? item.itemRichData.squareImageUrl : '';
											if (image && image.indexOf('http://') !== -1) {
												image = image.replace(/http:\/\//g, 'https://');
											}
											return (
												<div key={`basket-item_${basketItemIndex}`} className="box-content">
													{!getConfig().flags.removeMenuImages &&

														<div
															className="order-item-image"
															style={
																image && image !== ''
																	? { backgroundImage: `url(${image})` }
																	: {
																		backgroundSize: 'contain',
																		backgroundImage: `url(${Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.restaurantMenuItemImage ?? this.props.clientProfile.logo_image})`,
																	}
															}
														/>
													}
													<div className="item-content-wrapper flex-justify-between flex-row-wrapper">
														<div>
															<div style={{ display: 'grid', gridAutoFlow: 'column', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 'var(--spacer-0)' }}>
																<StrongText className="block text-to-update">{`${isAlreadyCreatedOrder ? `${quantity}x ` : ''}${Basket.getProductName(item, profile)}`}</StrongText>

																{handleOrderItemClick && (
																	<IonIcon className='pointer' icon={closeOutline} onClick={() => { this.setState({ showRemoveItemAlert: true, removeItemAlertFunction: () => handleOrderItemClick(basketItem, basketItemIndex, 0) }) }} />
																)}
															</div>


															{this.drawSubItemsText(basketItem, basketItemIndex)}
															{basketItem.instructions && basketItem.instructions !== '' && (
																<>
																	<Spacer size={2} />
																	<SmallText className="block">{`${__('Instructions')}: ${basketItem.instructions}`} </SmallText>
																</>
															)}
														</div>
														<div className="item-content-actions flex-justify-between flex-col-wrapper flex-align-center">
															<Incrementer
																onUpdate={(val) => {
																	if (handleOrderItemClick) {
																		handleOrderItemClick(basketItem, basketItemIndex, val);
																	}
																}}
																quantity={quantity}
																step={1}
																allowNegative={false}
																minLimit={1}

															>
																<StrongText className="bold primary-color">{quantity}</StrongText>
															</Incrementer>
															<StrongText>
																{basketInstance.calculateItemPriceByIndex(basketItemIndex, true) > 0 ? basketInstance._calculateItemPriceByIndex(basketItemIndex, true) : null}
															</StrongText>
														</div>
													</div>
												</div>
											);
										})}
									</div>
								</>
							)}
							<IonGrid className="box-content order-content-wrapper paddL">
								{!basketInstance.is_gift && !basketInstance.is_event ? (
									<IonRow>
										<IonCol>
											<IonCol ><StrongText className='text-to-update'>{__('Items total')}</StrongText></IonCol>
										</IonCol>
										<IonCol className="righted bold">{basketInstance.calculateItemsTotal()}</IonCol>
									</IonRow>
								) : null}
							</IonGrid>
							{this.renderUpsellSlider(this.getUpsellEntries())}
							{isAlreadyCreatedOrder &&
								basketInstance.getServiceChargeValue() > 0 &&
								<IonGrid className="box-content order-content-wrapper paddL">
									<div key="service_charge" className="basket-item-wrapper">
										<IonRow className="basket-item-service-charge-row service-charge-item" onClick={() => isAlreadyCreatedOrder ? () => { } : this.setState({ removeServiceChargeModal: true })}>
											<>
												<IonCol className="paddLR grow ">
													<StrongText className='text-to-update'>
														{__('Service charge')}
														{!isAlreadyCreatedOrder &&
															<>
																{basketInstance.service_charge_value ? (
																	<>&nbsp; {basketInstance.service_percentage !== 0 && ` ${basketInstance._getServicePercentage()}`}</>
																) : (
																	<>&nbsp; {basketInstance.service_percentage !== false && ` ${basketInstance._getServicePercentage()}`}</>
																)}
															</>}

													</StrongText>

												</IonCol>
												<IonCol className="righted paddLR self-center bold">
													{basketInstance.getServiceChargeValue() > 0 ? basketInstance.getFormatedServiceChargeValue() : basketInstance.getServiceCharge(true)}
												</IonCol>
											</>
										</IonRow>
										<Modal
											alertType
											actionLabel={__('Yes')}
											action={() => this.setState({ removeServiceChargeModal: false }, () => {
												basketInstance.setServiceCharge(0)
												basketInstance.setServicePercentage(0)

											})}
											isOpen={this.state.removeServiceChargeModal}
											onDidDismiss={() => this.setState({ removeServiceChargeModal: false })}
											noContent={true}
										>
											<StrongText>{__('Do you want to remove service charge') + ' ?'}</StrongText>
										</Modal>
									</div>
								</IonGrid>
							}
							{!isAlreadyCreatedOrder &&
								<>
									{((basketInstance.service_percentage > 0 || basketInstance.service_percentage === false) &&
										getConfig().general.service_charge_modules?.includes(Basket.order_type) &&
										getConfig().general.hasServiceCharge) &&
										getConfig().general.serviceChargeBoxHidden &&

										<IonGrid className="box-content order-content-wrapper paddL">
											<div key="service_charge" className="basket-item-wrapper">
												<IonRow className="basket-item-service-charge-row service-charge-item" onClick={() => this.setState({ serviceChargeBoxModalOpen: true })}>
													<>
														<IonCol className="paddLR grow ">
															<StrongText className='text-to-update'>
																{__('Service charge')}
																{basketInstance.service_charge_value ? (
																	<>{basketInstance.service_percentage !== 0 && ` ${basketInstance._getServicePercentage()}`}</>
																) : (
																	<>{basketInstance.service_percentage !== false && ` ${basketInstance._getServicePercentage()}`}</>
																)}
															</StrongText>

														</IonCol>
														<IonCol className="righted paddLR self-center bold">
															{basketInstance.getServiceChargeValue() > 0 ? basketInstance.getFormatedServiceChargeValue() : basketInstance.getServiceCharge(true)}
														</IonCol>
													</>
												</IonRow>

											</div>
										</IonGrid>
									}
								</>}

							{deliveryPriceUnformated > 0 ? (
								<IonGrid className="box-content order-content-wrapper paddL">
									<IonRow>
										<IonCol className="paddLR grow">
											<StrongText>
												{basketInstance.getRestaurant()?.delivery_charge_in_percent && basketInstance.getRestaurantDeliveryPrice()
													? `${basketInstance.getRestaurantDeliveryPrice()}% `
													: null}
												{__('Delivery Charge')}
											</StrongText>

										</IonCol>
										<IonCol className="righted paddLR bold">
											{deliveryPrice}
										</IonCol>
									</IonRow>
								</IonGrid>

							) : null}
							{basketInstance.process_fee_value > 0 && (
								<IonGrid className="box-content order-content-wrapper paddL">


									<IonRow className="">
										<>
											<IonCol className="paddLR grow ">
												<StrongText>
													{`${__('Processing fee')} ${Basket.processing_fee_description ? `${Basket.processing_fee_description}` : ''}`}


												</StrongText>

											</IonCol>
											<IonCol className="righted paddLR self-center bold ">{basketInstance.getProcessingFee()}</IonCol>
										</>
									</IonRow>
								</IonGrid>

							)}

							{basketInstance.discount && (
								<IonGrid className="box-content order-content-wrapper paddL">
									<IonRow>
										<IonCol className="paddLR grow">{basketInstance.discount.title}</IonCol>
										<IonCol className="righted paddLR bold">-{basketInstance.formatPrice(basketInstance.calculateMembershipDiscount())}</IonCol>
									</IonRow>
								</IonGrid>

							)}
							{basketInstance.getTotalTaxBreakdown() > 0 && (
								<>
									<StrongText style={{ margin: 'var(--spacer-2) 0' }}>{__('Taxes')}</StrongText>
									<IonGrid className={`box-content order-content-wrapper paddL `}>
										{basketInstance.getTaxDataForDisplay().map((taxLine, taxIndex) => (
											<div key={`tax_${taxIndex}`} style={{ position: 'relative' }}>
												<IonRow>
													<IonCol className="paddLR grow strong-text">{taxLine.tax_name}</IonCol>
													<IonCol className="righted paddLR self-center strong-text">{basketInstance.formatPrice(taxLine.tax_amount)}</IonCol>
												</IonRow>
											</div>
										))}
										<IonRow>
											<IonCol className="paddLR grow strong-text">{__('Total taxes')}</IonCol>
											<IonCol className="righted paddLR self-center strong-text">{basketInstance.formatPrice(basketInstance.getTotalTaxBreakdown(), true)}</IonCol>
										</IonRow>
									</IonGrid>
								</>
							)}

							{this.props.serviceChargeBoxAlertOpen && (
								<Modal backdropDismiss={false} className="modal-type-alert" isOpen={this.props.serviceChargeBoxAlertOpen}>
									{this.drawServiceChargeBox(__, service_charge, basketInstance)}
									<Spacer size={5} />
									<div className='alert-button-group'>
										<IonButton
											className='button-uppercase'
											color="secondary "
											onClick={() => {
												if (Basket._getServiceCharge() != 0) {
													basketInstance.setServicePercentage(0);

												}
												this.props.dispatch(setCommonProp('serviceChargeBoxAlertOpen', false));
												this.props.dispatch(setCommonProp('serviceChargeBoxAlertAction', false));
												if (this.props.serviceChargeBoxAlertAction) {
													this.props.serviceChargeBoxAlertAction()

												} else {
													this.finaliseTableOrder();

												}
											}}
										>
											{__('Not this time')}
										</IonButton>
										<IonButton
											className='button-uppercase'
											expand="block"
											color="primary"
											onClick={() => {
												this.props.dispatch(setCommonProp('serviceChargeBoxAlertOpen', false));
												this.props.dispatch(setCommonProp('serviceChargeBoxAlertAction', false));
												if (this.props.serviceChargeBoxAlertAction) {
													this.props.serviceChargeBoxAlertAction()

												} else {
													this.finaliseTableOrder();

												}
											}}
										>
											{__('Done')}
										</IonButton>
									</div>


								</Modal>
							)}
							<IonGrid class="box-wrapper order-content-wrapper">
								{isAlreadyCreatedOrder && isDefined(appliedPoints) && appliedPoints > 0 ? (
									<IonRow>
										<IonCol className="paddLR grow">
											<StrongText className='text-to-update'>
												{`${appliedPoints} ${__('points redeemed')}`}

											</StrongText>
										</IonCol>
										<IonCol className="righted paddLR bold">{basketInstance._calculatePointsAppliedPrice(null, true)}</IonCol>
									</IonRow>
								) : null}
								{isAlreadyCreatedOrder && appliedGiftCards &&
									basketInstance.getAppliedGiftCardsValue() > 0 &&
									appliedGiftCards
										.filter((card) => card.value > 0)
										.map((card) => {
											return (
												<IonRow key={card.id}>
													<IonCol size='7' className="paddLR grow"><StrongText className='text-to-update'>{`${__(card?.isEventCard ? 'Event card' : card?.isTopUpCard ? 'Top Up card' : 'Gift card')} ${getGiftCardNumber(card)}`}</StrongText> </IonCol>
													<IonCol className="righted paddLR bold">{basketInstance.formatPrice(card.value * -1)}</IonCol>
												</IonRow>
											);
										})}
								{appliedVoucher &&
									appliedVoucher.length > 0 &&
									appliedVoucher.map((voucher) => {
										let voucherName = voucher.name;
										if (voucher && voucher.reward && voucher.reward.name) {
											voucherName = voucher.reward.name;
										}
										return (
											<>
												<IonRow key={voucher.id} onClick={() => (isAlreadyCreatedOrder ? null : dispatch(setModal('isRemoveVoucherModalOpen', true)))}>
													<IonCol className="paddLR grow"><StrongText className='text-to-update'>{isAlreadyCreatedOrder ? __('Loyalty voucher applied') : __(voucherName)}</StrongText> </IonCol>
													<IonCol size='4' className="righted paddLR bold">{basketInstance._calculateAppliedVocuhersPrice(true, null)}</IonCol>
												</IonRow>
												<Modal
													alertType
													actionLabel={__('Yes')}
													action={() => dispatch(removeVoucher(voucher))}
													isOpen={!!isRemoveVoucherModalOpen}
													onDidDismiss={() => dispatch(setModal('isRemoveVoucherModalOpen', false))}
													noContent={true}
												>
													<StrongText>{__('Do you want to remove voucher') + '?'}</StrongText>
												</Modal>
											</>
										);
									})}

							</IonGrid>
							{(isAlreadyCreatedOrder || this.props.taxCalculated || !getConfig().flags.hasTaxBreakdown) && (

								<IonGrid class="box-wrapper order-content-wrapper order-content-total">
									<IonRow>
										<IonCol>
											<IonCol><StrongText className=" text-to-update">{isAlreadyCreatedOrder ? __('Total') : __('Total to pay')}</StrongText></IonCol>
										</IonCol>
										<IonCol className="righted  bold">{basketInstance._getTotal(true)}</IonCol>
									</IonRow>

									{!getConfig().flags.removePointsEarningFromCheckout && (points_value_percentage > 0 && !isAlreadyCreatedOrder && this.calculateOrderPoints(points_value_percentage) > 0) &&
										<IonRow style={{ gap: 'var(--spacer-0)', alignItems: 'flex-start', display: 'grid', gridTemplateColumns: 'auto 1fr', border: 'none', paddingTop: 0, height: 'auto' }}>
											<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
												<path d="M7.50016 18.3337H15.0002C15.6918 18.3337 16.2835 17.917 16.5335 17.317L19.0502 11.442C19.1252 11.2503 19.1668 11.0503 19.1668 10.8337V9.16699C19.1668 8.25033 18.4168 7.50033 17.5002 7.50033H12.2418L13.0335 3.69199L13.0585 3.42533C13.0585 3.08366 12.9168 2.76699 12.6918 2.54199L11.8085 1.66699L6.31683 7.15866C6.01683 7.45866 5.8335 7.87533 5.8335 8.33366V16.667C5.8335 17.5837 6.5835 18.3337 7.50016 18.3337ZM7.50016 8.33366L11.1168 4.71699L10.0002 9.16699H17.5002V10.8337L15.0002 16.667H7.50016V8.33366ZM0.833496 8.33366H4.16683V18.3337H0.833496V8.33366Z" fill="var(--ion-color-success)" />
											</svg>
											<NormalText className='success-color'>{`${__('You will earn')} ${this.calculateOrderPoints(points_value_percentage)} ${__('loyalty points on this order')}`}</NormalText>
										</IonRow>
									}
								</IonGrid>
							)}

							{basketInstance.service_percentage === 0 &&
								getConfig().general.service_charge_modules?.includes(Basket.order_type) &&
								getConfig().general.hasServiceCharge &&
								getConfig().general.serviceChargeBoxHidden &&
								basketInstance.getServiceChargeValue() === null ? (
								<>
									<div key="service_charge" className="basket-item-wrapper">
										<IonButton
											expand="block"
											color='secondary'

											className="link  basket-item-service-charge-row"
											onClick={() => this.setState({ serviceChargeBoxModalOpen: true })}
										>
											{__('Add a service charge')}
										</IonButton>
									</div>
								</>
							) : null}

							{getConfig().general.hasServiceCharge &&
								!basketInstance.service_charge_value &&
								basketInstance.service_charge_value !== 0 &&
								getConfig().general.service_charge_modules?.includes(Basket.order_type) && (
									<>
										{!getConfig().general.serviceChargeBoxHidden ? (
											<>{this.drawServiceChargeBox(__, service_charge, basketInstance)}</>
										) : (
											<>
												<Modal
													className="modal-type-alert"
													isOpen={this.state.serviceChargeBoxModalOpen}
													onDidDismiss={() => this.setState({ serviceChargeBoxModalOpen: false })}
												>
													<Spacer size={5} />
													{this.drawServiceChargeBox(__, service_charge, basketInstance)}
													<Spacer size={5} />
													<div className='alert-button-group'>
														<IonButton
															className='button-uppercase'
															color="secondary "
															onClick={() => {
																basketInstance.setServicePercentage(0);
																this.setState({ serviceChargeBoxModalOpen: false });
															}}
														>
															{__('Not this time')}
														</IonButton>
														<IonButton
															className='button-uppercase'
															expand="block"
															color="primary"
															onClick={() => {
																this.setState({ serviceChargeBoxModalOpen: false });
															}}
														>
															{__('Done')}
														</IonButton>

													</div>
												</Modal>
											</>
										)}


									</>
								)}

							{getConfig()?.customExternalLinks?.checkout &&
								<>
									<Spacer size={3} />
									<IonButton
										onClick={() => {
											openExternalLink(getConfig().customExternalLinks.checkout?.url)
										}}
										color="secondary"
										className="link "
									>
										{__(getConfig().customExternalLinks.checkout?.title)}
									</IonButton>
								</>
							}
							{getConfig().general.allergenList &&
								<>

									<CheckoutAllergens allergens={basketInstance?.additional_data?.allergen_list} isAlreadyCreatedOrder={isAlreadyCreatedOrder} allergenError={this.props.allergenError} />
								</>
							}
							<Modal className="modal-type-alert" isOpen={serviceChargeModalOpen} onDidDismiss={() => this.handleServiceChargeModal(false)}>
								<StrongText className='block text-to-update'>{__('Add custom amount')}</StrongText>
								<Spacer size={5} />
								<IonItem lines="none" className="input-field-wrapper input-field-wrapper-with-floating-text ">
									<NormalText className='input-field-floating-text label-color'>{Basket.getCurrency().label}</NormalText>
									<IonInput value={this.state.serviceChargeAmount} clearInput onIonInput={(e) => this.setCustomServiceCharge(e.target.value)} type="number" pattern="number" inputmode="number"></IonInput>
								</IonItem>

								{this.state.customAmountErrorVisible && (
									<>
										<SmallText className="danger-color">{__('Value can not be negative')}</SmallText>
									</>
								)}
								<Spacer size={5} />
								<div className='alert-button-group'>
									<IonButton
										className='button-uppercase'
										expand="block"
										color={'secondary'}
										onClick={() => {
											this.handleServiceChargeModal(false)
										}}
									>
										{__('Cancel')}
									</IonButton>
									<IonButton
										className='button-uppercase'
										expand="block"
										onClick={() => {
											basketInstance.setServiceCharge(this.state.serviceChargeAmount);
											this.setState({ serviceChargeModalOpen: false });
										}}
										disabled={!this.state.serviceChargeAmount}
									>
										{__('Add')}
									</IonButton>
								</div>

							</Modal></>}

					</>
				}


				<IonAlert
					isOpen={showRemoveItemAlert}
					onDidDismiss={() => {
						this.setState({ showLastItemAlert: false });
					}}
					className='remove-title-update'
					header={__('Are you sure you want to remove the selected item?')}
					message={__('')}
					buttons={[

						{
							text: __('Yes'),
							cssClass: 'primary',

							handler: () => this.setState({ showRemoveItemAlert: false }, () => removeItemAlertFunction())
						},
						{
							text: __('No'),
							role: 'cancel',
							cssClass: 'secondary link',
							handler: () => this.setState({ showRemoveItemAlert: false, removeItemAlertFunction: () => null }),
						},
					]}
				/>
				{this.state.selectedUpsellItem &&
					<ModalItem
						selectedUpsellRestaurant={this.state.selectedUpsellRestaurant}
						item={this.state.selectedUpsellItem}
						onClose={() => this.setState({ selectedUpsellItem: null })}
					/>
				}

			</>
		);
	}
}

const mapStateToProps = (store) => {
	return {
		profile: store.profile.profile,
		isRemoveVoucherModalOpen: store.profile.isRemoveVoucherModalOpen,
		clientProfile: store.common.clientProfile,
		taxContentLoading: store.common.taxContentLoading,
		taxCalculated: store.common.taxCalculated,
		serviceChargeBoxAlertOpen: store.common.serviceChargeBoxAlertOpen,
		basketUpdated: store.orders.basketUpdated,
		serviceChargeBoxAlertAction: store.common.serviceChargeBoxAlertAction
	};
};

export default connect(mapStateToProps)(withRouter(withTranslation(OrderContent)));
